export class EnableSourceAccountMetricsConfigResponse {
    'sourceAccountConfig';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "sourceAccountConfig",
            "baseName": "sourceAccountConfig",
            "type": "SourceAccountMetricsConfig",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return EnableSourceAccountMetricsConfigResponse.attributeTypeMap;
    }
    constructor() {
    }
}
